import { useState } from "react";
import { useHistory } from "react-router-dom";
import { ROUTES } from "@constants";
import { getOrderAuthorization, OrderAuthorizationEnum } from "@utils/getOrderAuthorization";
import { getIsUserLinked, getProspectReference, saveLinkedUser, saveUserInformation } from "@utils/storage";
import { useCreateProspect } from "./useCreateProspect";
import { getResponseToState, ICartResponse } from "@mappers/getCartMapper";
import { useFetch } from "./useFetch";
import { getCartRoute, transferProspectToCrossSellRoute } from "@api-routes/eirSalesFacade";

export const useLinkProspect = () => {
    const [linkProspectUserState, { post, get }] = useFetch();
    const { callCreateProspect, createProspectState } = useCreateProspect();
    const [displayChangedInfoModal, setDisplayChangedInfoModal] = useState(false);
    const { push, location } = useHistory();

    const callLinkUser = (prospectReference: string) => {
        if (!getIsUserLinked()) {
            return post<string>(transferProspectToCrossSellRoute(prospectReference)).then((crossSellReference) => {
                if (crossSellReference) {
                    saveUserInformation(crossSellReference);
                    saveLinkedUser();
                    get<ICartResponse>(getCartRoute(crossSellReference), {
                        headers: {
                            "Cache-Control": "no-cache",
                        },
                    }).then((userCartResponse) => {
                        if (userCartResponse) {
                            const userCart = getResponseToState(userCartResponse);

                            const orderAuthorization = getOrderAuthorization(userCart);
                            const noMoreSubscriptionsAllowed = userCart.nbrAdditionalAllowedMobileSubscriptions < 0;

                            if (
                                noMoreSubscriptionsAllowed &&
                                orderAuthorization === OrderAuthorizationEnum.OrderImpossible
                            ) {
                                push(ROUTES.BASE_URL);
                            } else if (
                                noMoreSubscriptionsAllowed &&
                                orderAuthorization === OrderAuthorizationEnum.TooMuchOffer
                            ) {
                                push(ROUTES.CART_PAGE_URL);
                            } else if (!noMoreSubscriptionsAllowed && location.pathname === ROUTES.SUMMARY_PAGE_URL) {
                                setDisplayChangedInfoModal(true);
                            }
                        }
                    });
                }
            });
        }

        return Promise.resolve();
    };

    const linkProspect = () => {
        const prospectReference = getProspectReference();
        if (prospectReference) {
            return callLinkUser(prospectReference);
        }

        return callCreateProspect().then((reference) => {
            if (reference) {
                return callLinkUser(reference);
            }

            return Promise.resolve();
        });
    };

    return {
        createProspectState,
        displayChangedInfoModal,
        linkProspect,
        linkProspectUserState,
        setDisplayChangedInfoModal,
    };
};
